import React from 'react';
import classnames from 'utils/classnames';

type BadgeProps = {
  color: 'Blue' | 'Gold';
  children?: React.ReactNode;
};

const Badge: React.FC<BadgeProps> = (props) => {
  const { color } = props;
  // <div className={'prisma w-full pt-2 pb-4 md:pt-0 md:pb-0'}>
  return (
    <div className={'flex items-center justify-center md:justify-start'}>
      <span
        className={classnames('rounded-full px-4 py-1 text-sm', {
          'bg-sf-blue-700 text-white': color === 'Blue',
          'bg-sf-gold-300 text-white': color === 'Gold',
        })}
      >
        {props.children}
      </span>
    </div>
  );
};
export default Badge;
